import { Empty, Tag } from "antd";
import {
  ImageCheck,
  LinkWrapper,
  LoadingListEntityProfile,
} from "Explore/Components";
import { useNavigate } from "react-router-dom";
import styles from "./VenueTopInstitutions.module.scss";
import { IconPack } from "Explore/Config/Icons";
import { ImageCheckType } from "Explore/Config/ImageType";
import { numberRegex } from "Explore/Utils/numberRegex";
import getInstitutionDescription from "./getInstitutionDescription";

const TopInsitution = ({ inst, index }) => {
  const statistics = [
    {
      title: "h-index",
      value: inst.specific_stats.h_index,
      icon: IconPack.h_index,
    },
    {
      title: "citations",
      value: inst.specific_stats.citation_count,
      icon: IconPack.citation,
    },
    {
      title: "publications",
      value: inst.specific_stats.publication_count,
      icon: IconPack.publications,
    },
  ];

  return (
    <div className={styles["inst"]}>
      {!!inst.specific_stats.rank && (
        <div className={styles["inst__left"]}>
          <div className={styles["ranking"]}>
            <span>#</span>
            <span className={styles["ranking--index"]}>
              {inst.specific_stats.rank}
            </span>
          </div>
        </div>
      )}
      <div className={styles["inst__right"]}>
        <div className={styles["inst__right__top"]}>
          <div className={styles["avatar"]}>
            <ImageCheck
              url={inst.photo_url}
              className={styles["photo"]}
              alt={"avatar"}
              type={ImageCheckType.INSTITUTION_LOGO}
            />
          </div>

          <div className={styles["info"]}>
            <div className={styles["info__top"]}>
              <LinkWrapper
                component={
                  <div>
                    <p className={styles["name"]}>{inst.inst_name}</p>
                  </div>
                }
                link={`/explore/institution/${inst.explore_slug || inst.id}`}
              />

              <div className={styles["score"]}>
                {IconPack.score}
                <span>Score:</span>&nbsp;{Math.round(inst.score * 100) / 100}
              </div>
            </div>

            {/* <p className={styles["bio"]}>
              {getInstitutionDescription(inst, index)}
            </p> */}
          </div>
        </div>
        <div className={styles["inst__right__bottom"]}>
          {/* <div className={styles["statistics"]}>
              {statistics
                .filter((e) => !!e.value)
                .map(({ title, value, icon }) => (
                  <div className={styles["statistics__item"]} key={title}>
                    <div className={styles["statistics__item--icon"]}>{icon}</div>
                    <div className={styles["statistics__item--content"]}>
                      <p className={styles["statistics__item--value"]}>
                        {numberRegex(value)}
                      </p>
                      <p className={styles["statistics__item--title"]}>{title}</p>
                    </div>
                  </div>
                ))}
            </div> */}
          <div className={styles["tags"]}>
            {inst.keywords.map((item, index) => {
              return (
                <Tag
                  key={index}
                  color="var(--light-blue)"
                  style={{ color: "var(--dark-grey)" }}
                >
                  {item.id}
                </Tag>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

const VenueTopInstitutions = ({ data, isLoading, pagination }) => {
  return (
    <div className={styles["venue-top-institutions"]}>
      <LoadingListEntityProfile
        isLoading={isLoading}
        component={
          data.length > 0 ? (
            data?.map((item, index) => {
              return (
                <TopInsitution
                  inst={item}
                  key={index}
                  index={index + (pagination.page - 1) * pagination.rowsPerPage}
                />
              );
            })
          ) : (
            <Empty description="No institution Found." />
          )
        }
        componentNum={10}
        rows={2}
        avatar={true}
      />
    </div>
  );
};

export default VenueTopInstitutions;
